<template>
  <v-content class="align-center justify-center pt-0 mt-4 mx-4">
    <v-container fluid fill-height class="pl-0 pr-0 pt-0">
      <v-layout align-center justify-center>
        <v-flex xs12 sm8 md4 lg8>
          <v-card elevation="5" style="border-radius: 6px !important;">
            <v-form @submit.prevent="onLogin">
              <v-row no-gutters style="padding-top:50px;">
                <v-col
                  lg="6"
                  md="12"
                  sm="12"
                  class="px-auto d-flex align-center justify-center"
                >
                  <img
                    :src="empresa.empStrLogoPath"
                    width="90%"
                    height="auto"
                    class="mx-auto"
                    v-if="empresa"
                  />
                </v-col>

                <v-col lg="6" md="12" sm="12" class="px-auto">
                  <v-card-text class="px-12">
                    <v-text-field
                      v-model.trim="cliente"
                      label="E-mail"
                      prepend-icon="las la-user"
                      title="Login fornecido pela Lume"
                      color="var(--vs-azul-secundaria)"
                    ></v-text-field>
                    <v-text-field
                      v-model.trim="senha"
                      label="Senha"
                      prepend-icon="las la-lock"
                      title="Senha fornecida pela Lume"
                      :type="passwordVisibility ? 'text' : 'password'"
                      :append-icon="
                        passwordVisibility ? 'visibility_off' : 'visibility'
                      "
                      @click:append="
                        () => (passwordVisibility = !passwordVisibility)
                      "
                      color="var(--vs-azul-secundaria)"
                    ></v-text-field>
                  </v-card-text>
                  <div class="text-center" style="padding-bottom:30px;">
                    <v-card-actions class="align-center">
                      <v-row no-gutters class="justify-center">
                        <vs-button
                          color="warning"
                          style="min-width: 130px"
                          animation-type="scale"
                          class="float-right"
                        >
                          <i
                            class="las la-user-circle mr-3"
                            style="font-size: 20px !important"
                          ></i>
                          <template>Login</template>
                        </vs-button>
                        <vs-button
                          color="primary"
                          border
                          style="min-width: 130px"
                          @click="novaConta()"
                        >
                          <template>Cadastre-se</template>
                        </vs-button>
                      </v-row>
                    </v-card-actions>
                    <v-row no-gutters class="d-flex justify-center">
                      <v-dialog
                        v-model="dialogEsqueciSenha"
                        persistent
                        max-width="400px"
                      >
                        <template v-slot:activator="{ on }">
                          <v-btn
                            text
                            small
                            color="var(--vs-azul-primaria)"
                            class="d-flex"
                            v-on="on"
                            >Esqueci minha senha</v-btn
                          >
                        </template>
                        <v-card>
                          <v-card-title>
                            <span class="headline">Esqueci minha senha</span>
                          </v-card-title>
                          <v-card-text>
                            <v-container>
                              <v-row>
                                <v-col cols="12" sm="12" md="12">
                                  <v-text-field
                                    v-model="meuLogin"
                                    label="Informe seu e-mail"
                                    type="text"
                                    required
                                    color="var(--vs-azul-secundaria)"
                                  ></v-text-field>
                                </v-col>
                              </v-row>
                            </v-container>
                          </v-card-text>
                          <v-card-actions>
                            <v-spacer></v-spacer>
                            <v-btn
                              color="var(--vs-azul-secundaria)"
                              text
                              @click="dialogEsqueciSenha = false"
                              >Fechar</v-btn
                            >
                            <v-btn
                              color="var(--vs-azul-primaria)"
                              text
                              @click="esqueciMinhaSenha(meuLogin)"
                              >Enviar</v-btn
                            >
                          </v-card-actions>
                        </v-card>
                      </v-dialog>
                    </v-row>
                  </div>
                </v-col>
                <v-col>
                  <p class="grey--text text--darken-1 text-center caption px-8">
                    &copy; {{ new Date().getFullYear() }} Lume Serviços de
                    Tecnologia S.A. - All rights reserved. - {{ version }}
                  </p>
                </v-col>
              </v-row>
            </v-form>
          </v-card>
        </v-flex>
      </v-layout>
    </v-container>
  </v-content>
</template>

<script>
import { mapState, mapGetters } from "vuex";
import { version } from "./../../package.json";

export default {
  data() {
    return {
      cliente: "",
      senha: "",
      passwordVisibility: false,
      dialogEsqueciSenha: false,
      meuLogin: "",
    };
  },
  computed: {
    ...mapState({
      showError: (state) =>
        state.core.error !== null && state.core.error !== "",
      user: (state) => state.cliente.user,
      p: (state) => state.cliente.p,
      loading: (state) => state.core.loading,
    }),
    ...mapGetters({
      empresa: "anuncio/empresa",
    }),
    version() {
      return version;
    },
  },

  watch: {
    user(value) {
      if (value !== null && value !== undefined) {
        if (this.p) {
          this.$router.push({ name: "anuncio", query: { p: this.p } });
          this.$store.dispatch("cliente/removerParametroFiltro");
        } else {
          this.$router.push({ name: "anuncio" });
        }
      }
    },
  },
  methods: {
    onLogin() {
      this.$store.dispatch("cliente/login", {
        cliente: this.cliente,
        senha: this.senha,
        empIntCod: this.$route.params.id,
      });      
    },
    esqueciMinhaSenha(login) {
      // console.log(login, this.$route.params.id);
      this.$store.dispatch("cliente/esqueciMinhaSenha", {
        busStrLogin: login,
        empIntCod: this.$route.params.id,
      });
      this.meuLogin = "";
    },
    novaConta() {
      this.$store.commit("cliente/limpaClienteNovo");
      this.$router.push({ name: "registro" });
    },
    onDismissed() {
      this.$store.dispatch("core/clearError");
    },
  },
};
</script>

<style>
.v-application .primary--text {
  color: #a5d6a7 !important;
  caret-color: #a5d6a7 !important;
}

.v-image__image {
  margin-top: 20px !important;
}

.v-messages__message {
  left: 60px;
  padding-top: 10%;
  position: fixed;
}

.swal2-title {
  font-size: 1.4em !important;
}

.v-sheet {
  border-radius: unset !important;
}

.col {
  flex-basis: unset !important;
}

.conteudo {
  padding-top: 64px;
}

/* .v-input
  .v-input--is-focused
  .theme-light
  .v-text-field--is-booted
  .primary--text {
  color: #a5d6a7 !important;
  caret-color: #a5d6a7 !important;
}

.v-label .v-label--active .theme--light .primary--text {
  color: #a5d6a7 !important;
  caret-color: #a5d6a7 !important;
} */
</style>
